import React, { useEffect } from 'react';
import { BeakerIcon } from '@heroicons/react/24/outline';

function FuelLogs() {
  useEffect(() => {
    document.title = 'Fuel Logs - Sales Assist';
    return () => {
      document.title = 'Sales Assist';
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 pt-20">
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-gray-200 px-6 py-4">
        <div className="flex items-center space-x-3">
          <div className="p-2 rounded-lg bg-yellow-100">
            <BeakerIcon className="w-6 h-6 text-yellow-600" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Fuel Logs</h1>
            <p className="text-sm text-gray-600 mt-1">Track and manage fuel consumption and expenses</p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="py-6">
        <div className="px-6">
          <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-12 text-center">
            <div className="max-w-md mx-auto">
              <BeakerIcon className="w-20 h-20 text-gray-300 mx-auto mb-6" />
              <h2 className="text-2xl font-bold text-gray-900 mb-3">Fuel Log Management Coming Soon</h2>
              <p className="text-gray-600 mb-6">
                The fuel log management system is currently under development. This feature will allow you to:
              </p>
              <ul className="text-left text-gray-600 space-y-2 mb-8">
                <li className="flex items-start">
                  <span className="text-yellow-600 mr-2">•</span>
                  <span>Record fuel purchases and consumption</span>
                </li>
                <li className="flex items-start">
                  <span className="text-yellow-600 mr-2">•</span>
                  <span>Track fuel costs per vehicle</span>
                </li>
                <li className="flex items-start">
                  <span className="text-yellow-600 mr-2">•</span>
                  <span>Calculate fuel efficiency metrics</span>
                </li>
                <li className="flex items-start">
                  <span className="text-yellow-600 mr-2">•</span>
                  <span>Generate fuel expense reports</span>
                </li>
                <li className="flex items-start">
                  <span className="text-yellow-600 mr-2">•</span>
                  <span>Monitor fuel card transactions</span>
                </li>
              </ul>
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
                <p className="text-sm text-yellow-800">
                  <strong>Note:</strong> This feature will be available in a future update.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FuelLogs;

